export interface PaymentSchedule {
  scheduleDates: string[]
  preferredPaymentDay: number
}

export enum PaymentTypeIntention {
  MONTHLY = 'MONTHLY',
  ANNUAL = 'ANNUAL',
}
